import { Link } from 'react-router-dom'
import { Article } from '@/types'
import { getImageUrl } from '@/utils/helpers'
import './LatestNews.css'

interface LatestNewsProps {
  articles: Article[]
}

function LatestNews({ articles }: LatestNewsProps) {
  if (articles.length === 0) {
    return null
  }

  const formatDate = (dateString: string) => {
    const date = new Date(dateString)
    return new Intl.DateTimeFormat('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }).format(date)
  }

  const getAuthorName = (article: Article) => {
    if (!article.author) return null
    return `${article.author.first_name} ${article.author.last_name}`
  }

  return (
    <section className="latest-news">
      <div className="container">
        <h2 className="section-title">Dernières actualités</h2>
        <p className="section-subtitle">
          Restez informé des dernières nouvelles et événements de la campagne
        </p>

        <div className="news-grid">
          {articles.map((article) => {
            const coverImage = article.cover_media?.file_path
              ? getImageUrl(article.cover_media.file_path)
              : null
            const authorName = getAuthorName(article)

            return (
              <article key={article.id} className="news-card">
                {coverImage && (
                  <div className="news-card-image">
                    <img src={coverImage} alt={article.title} />
                  </div>
                )}
                <div className="news-card-content">
                  <div className="news-card-meta">
                    <span className="news-card-date">
                      {formatDate(article.published_at)}
                    </span>
                    {authorName && (
                      <span className="news-card-author">
                        Par {authorName}
                      </span>
                    )}
                  </div>
                  <h3 className="news-card-title">{article.title}</h3>
                  <p className="news-card-excerpt">{article.excerpt}</p>
                  <Link
                    to={`/actualites/${article.slug}`}
                    className="news-card-link"
                  >
                    Lire la suite →
                  </Link>
                </div>
              </article>
            )
          })}
        </div>

        <div className="section-cta">
          <Link to="/actualites" className="btn btn-primary">
            Voir toutes les actualités
          </Link>
        </div>
      </div>
    </section>
  )
}

export default LatestNews
